(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tf-premium-catalogue"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.tfp-showcase').forEach(showcase => {
  const controls = showcase.querySelector('.tfp-worlds');
  if (!controls) return;
  controls.style.visibility = 'visible';
  controls.addEventListener('click', event => {
    const button = event.target.closest('[data-select-world]');
    if (!button) return;
    showcase.querySelectorAll('[data-world]').forEach(panel => {
      panel.hidden = panel.dataset.world !== button.dataset.selectWorld;
    });
    controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  });
});
document.querySelectorAll('.tfp-filters').forEach(fieldset => {
  fieldset.addEventListener('click', event => {
    const input = event.target.closest('input[name="tfp-style"]');
    if (!input) return;
    event.stopPropagation();
    setTimeout(() => { input.checked = true; }, 0);
  });
});
  } catch(e) { console.error(e); }
})();

})();
